// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x-Zt","importantInfo":"styles_importantInfo__3_Sxb"};